import { render, staticRenderFns } from "./ConfigTextToSpeechList.vue?vue&type=template&id=219371d8&scoped=true"
import script from "./ConfigTextToSpeechList.vue?vue&type=script&lang=js"
export * from "./ConfigTextToSpeechList.vue?vue&type=script&lang=js"
import style0 from "./ConfigTextToSpeechList.vue?vue&type=style&index=0&id=219371d8&prod&scoped=true&lang=css"
import style1 from "./ConfigTextToSpeechList.vue?vue&type=style&index=1&id=219371d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219371d8",
  null
  
)

export default component.exports